module.exports = __webpack_public_path__ + "static/media/smallDown.ab73e38a.svg";